module.exports = __webpack_public_path__ + "img/professional team.6515cb7e.png";